import * as React from "react";

const ReportingPeriodPopover = (
  <div className="filename-popover">
    <p>
      <strong>Reporting Period:</strong> This is the time span for which data
      will be generated.
      <br />
      For example a file with a 1 day reporting period will contain data for a
      single day
      <br />
      while a file with a 1 week reporting period will contain data for 7 days.
      Note that
      <br />
      this is not related to the file delivery schedule which defines when files
      will be
      <br />
      delivered. The file delivery schedule is defined in the next section.
    </p>
  </div>
);

export default ReportingPeriodPopover;



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/StageOne/ReportFormat/ReportingPeriodPopover.tsx